const styles = `:host {
  height: auto;
  font: inherit;
  --stroke-width: 0;
}
:host div[part=heading] {
  color: var(--goto-type-color-default);
  height: auto;
  font: inherit;
  gap: var(--goto-spacing-02);
  padding-inline-start: var(--goto-spacing-01);
  padding-block: var(--goto-spacing-01);
}
:host div[part=heading] button {
  color: inherit;
  font: inherit;
  height: 100%;
  padding: 0;
  outline: none;
}
:host div[part=heading] button:focus-visible::before {
  border-color: var(--goto-focus-border-color-default);
  border-radius: 0;
  outline: 1px solid var(--goto-focus-color-highlight-default);
}
:host div[part=heading]:hover {
  background-color: var(--goto-interactive-color-secondary-hover);
}
:host div[part=heading]:active {
  background-color: var(--goto-interactive-color-secondary-pressed);
}
:host .region {
  padding-inline: var(--goto-spacing-04);
  padding-block-start: var(--goto-spacing-02);
  padding-block-end: var(--goto-spacing-06);
}
:host .start,
:host [name=expanded-icon],
:host [name=collapsed-icon] {
  --goto-icon-color: var(--goto-icon-color-default);
  --goto-icon-size: 20px;
  --design-unit: 8;
}

:host([chevron-position=left]) div[part=heading] {
  padding-inline-start: var(--goto-spacing-03);
}
:host([chevron-position=left]) button {
  margin-inline-end: auto;
}
:host([chevron-position=left]) .icon {
  grid-column: 1/auto;
}
:host([chevron-position=left]) [part=start],
:host([chevron-position=left]) [part=end] {
  display: none;
}

:host([divider=top]) div[part=heading] {
  border-top: 1px solid var(--goto-border-color-default);
}

:host([divider=bottom]) div[part=heading] {
  border-bottom: 1px solid var(--goto-border-color-default);
}

:host([divider=top-bottom]) div[part=heading] {
  border-top: 1px solid var(--goto-border-color-default);
}

:host([divider=top-bottom]:last-of-type) div[part=heading] {
  border-bottom: 1px solid var(--goto-border-color-default);
}

:host([divider=top-bottom]:last-of-type.expanded) div[part=heading],
:host([divider=bottom].expanded) div[part=heading] {
  border-bottom: none;
}
:host([divider=top-bottom]:last-of-type.expanded) .region,
:host([divider=bottom].expanded) .region {
  border-bottom: 1px solid var(--goto-border-color-default);
}

:host([size=small]) div[part=heading] {
  height: var(--goto-spacing-06);
  padding-block: 0;
}
:host([size=small]) [name=expanded-icon],
:host([size=small]) [name=collapsed-icon],
:host([size=small]) .start {
  --goto-icon-size: var(--goto-spacing-04);
}

:host([size=large]) div[part=heading] {
  padding-block: var(--goto-spacing-02);
}

:host([full-width]) .region {
  padding: 0;
}

:host([disabled]) {
  pointer-events: none;
}
:host([disabled]) div[part=heading] {
  color: var(--goto-type-color-disabled);
}
:host([disabled]) .start,
:host([disabled]) [name=expanded-icon],
:host([disabled]) [name=collapsed-icon] {
  --goto-icon-color: var(--goto-icon-color-disabled);
}

::slotted(chameleon-navigation-drawer-item) {
  width: 100%;
  padding-inline-start: var(--goto-spacing-09);
}`; export default styles;